( function( $ ) {
	var $teacherImages = $( '.retreat__teacher-profiles__teacher-img' );

	if ( $teacherImages.length ) {
		$.each( $teacherImages, function ( index, element ) {
			$( element ).on( 'error', function() {
				element.removeAttribute( 'src' );
				var newElement = document.createElement( 'div' );
				newElement.className = 'retreat__teacher-profiles__teacher-img placeholder';
				element.parentNode.classList.add( 'placeholder' );
				element.parentNode.replaceChild( newElement, element );
			} );
		} );
	}

	var $smallTeacherImages = $( '.retreat-list__teacher-image' );

	if ( $smallTeacherImages.length ) {
		$.each( $smallTeacherImages, function ( index, element ) {
			$( element ).on( 'error', function() {
				element.removeAttribute( 'src' );
				var newElement = document.createElement( 'div' );
				newElement.className = 'retreat-list__teacher-image placeholder';
				element.parentNode.classList.add( 'placeholder' );
				element.parentNode.replaceChild( newElement, element );
			} );
		} );
	}

	$.each( $( '.teacher__audio' ), function( index, el ) {
		new Plyr( el );
	} );

	$( '.faculty-dropdown__header' ).on( 'click', (e) => {

		let $dropdown = e.currentTarget.parentNode.parentNode

		if ( $dropdown.classList.contains('active') ) {
			$dropdown.classList.remove('active')
			return
		}

		$('.faculty-dropdown').removeClass('active')
		$dropdown.classList.toggle('active')
	})

	$( '.faculty-dropdown__item' ).on( 'click', function() {
		let $select = $( this ).parents( '.faculty-dropdown' )
		updateDropdownMenu( this, $select )
	})
} ( jQuery ) )



// WEBPACK FOOTER //
// ./assets/js/components/layout/teacher-images.js